import { render, staticRenderFns } from "./FieldType25.vue?vue&type=template&id=4248d971&scoped=true"
import script from "./FieldType25.vue?vue&type=script&lang=js"
export * from "./FieldType25.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4248d971",
  null
  
)

export default component.exports